import { Badge } from "@loot-os/ui/components/badge";

export function DisputeStatusBadge({ status }: { status: string }) {
  const variant =
    status === "won" || status === "prevented"
      ? "default"
      : status === "under_review" || status === "warning_under_review"
        ? "secondary"
        : status === "warning_closed"
          ? "outline"
          : "destructive"; // needs_response / lost want eyes on them
  return <Badge variant={variant}>{status.replaceAll("_", " ")}</Badge>;
}
